import Inputs from './inputs/inputs';
import Results from './results/results';

export default class IndexModel {
  inputs;
  opAmpSource;

  constructor(opampService) {
    this.opAmpSource = opampService;
    this.inputs = new Inputs();
  }
  get results() {
    return Results.create({ inputs: this.inputs, opAmpSource: this.opAmpSource });
  }
}
